<script>
import { StoryCommentElementMixin } from "%/dynamic-component-editor/standard-components/story-comment/story-comment-element-mixin";
import { DateElementMixin } from "%/dynamic-component-editor/standard-elements/text-element/date-element-mixin";
import TextElement
  from "%/dynamic-component-editor/standard-elements/text-element/TextElement.vue";
import BrandedTextStyleOptions from "%/dynamic-component-editor/bundles/branded-text-style-options";

export default {
  name: "StoryCommentCreated",
  elementPanelSettings: {
    displayName: "Comment Created",
    displayIcon: "text-alt",
    elementGroup: "Story Comments",
    elementType: "element",
  },
  extends: TextElement,
  mixins: [StoryCommentElementMixin, DateElementMixin],
  optionBundles: [
    new BrandedTextStyleOptions({}, {
      "text-option": true,
    }),
  ],
  computed: {
    isEditable() {
      return false;
    },
    value() {
      return this.formattedDate(this.entity.timestampContentUpdated);
    },
    shouldShowText() {
      return this.entity.timestampContentUpdated;
    },
  },
};
</script>
